import { Route } from '@angular/router';
import { RoutePath } from '../enums/routes.enum';
import { authGuard } from '../guards/auth.guard';
import { registerGuard } from '../guards/register.guard';

export const appRoutes: Route[] = [
  {
    path: RoutePath.Landing,
    loadComponent: () => import('../pages/landing/landing.component'),
    canActivate: [authGuard],
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
  },
  {
    path: RoutePath.ResetPassword,
    loadComponent: () =>
      import('../pages/reset-password/reset-password.component'),
    canActivate: [authGuard],
  },
  {
    path: RoutePath.AuthAction,
    loadComponent: () => import('../pages/auth-action/auth-action.component'),
  },
  {
    path: RoutePath.RegisterUser,
    loadComponent: () =>
      import('../pages/register-user/register-user.component'),
    canActivate: [authGuard, registerGuard],
  },
  {
    path: RoutePath.Public,
    loadComponent: () =>
      import('../pages/public-platform/public-platform.component'),
    canActivate: [authGuard],
    loadChildren: () =>
      import('../pages/public-platform/public-platform.routes'),
  },
  {
    path: '',
    loadComponent: () => import('../pages/platform/platform.component'),
    canActivate: [authGuard, registerGuard],
    loadChildren: () => import('../pages/platform/platform.routes'),
  },
];
